<template>
    <div class="ex-release" :style="{ height: isActive ? '850px' : '870px' }">

        <div class="title">
            <p :class="{ backImgColor: isActive }" @click="isActiveChange1()">
                Purchasing
            </p>
            <p :class="{ backImgColor: !isActive }" @click="isActiveChange2()">
                Supplying
            </p>
        </div>

        <div class="p-box" v-if="!isActive && isExLogin_com == '个人'">
            <div class="p-box_select">
                <span class="label" style="margin-left: 0">Company</span>
                <Input type="text" placeholder="Company" style="
                        width: 200px;
                        height: 42px;
                        margin-left: 20px;
                        margin-top: 6px;
                    " v-model="zCompanyName" />
            </div>
            <div class="p-box_select">
                <span class="label" style="margin-left: 0">Product name</span>
                <Input type="text" placeholder="Product name" style="
                        width: 200px;
                        height: 42px;
                        margin-left: 20px;
                        margin-top: 6px;
                    " v-model="PersonProdcutName" />
            </div>
            <div class="p-box_select">
                <span class="label" style="margin-left: 0">Product Introduction</span>
                <Input type="textarea" placeholder="Product Introduction" style="
                        width: 200px;
                        height: 42px;
                        margin-left: 20px;
                        margin-top: 6px;
                    " v-model="PersonProductIntroduction" />
            </div>
            <div class="p-box_select" style="margin-top: 20px;">
                <span class="label" style="margin-left: 0">Product drawing</span>
                <Upload ref="upload" :show-upload-list="false" :on-success="handleSuccess5" :action="uploadUrl2"
                    style="margin-right: 10px">
                    <img v-if="PersonProductImg" :src="PersonProductImg" style="width: 120px;height:110px">
                    <img v-else
                        :src="uploadIcon"
                        alt="" style="width: 120px;height:110px">
                </Upload>

            </div>
            <div class="p-box_select">
                <span class="label" style="margin-left: 0">Contact authentication</span>
                <Button class="layui-btn" style='border-color: #EE1c5D;' type="primary" @click="goAuthentication"
                    v-if='!isAuth'>Go authenticate</Button>
                <div v-if='isAuth'>
                    <p>You have completed contact authentication.</p>
                    <p style='color: #EE1c5D;cursor: pointer;' @click='goAuthentication'>Click to modify</p>
                </div>
            </div>

            <div class="btn" @click="zSubmitForm_per()">
                Release demand
            </div>
        </div>


        <div class="p-box" v-else>
            <div class="p-box_select" v-if="isActive">
                <span class="label" style="margin-left: 0">Supply and demand type</span>
                <Select v-model="typeId" style="
                        width: 146px;
                        height: 42px;
                        margin-left: 20px;
                        margin-top: 6px;
                    ">
                    <Option v-for="item in typeList" :value="item.nameEn" :key="item.nameEn">{{ item.nameEn }}</Option>
                </Select>
            </div>

            <div class="p-box_select" v-if="isActive">
                <span class="label">Purchase Product Type</span>
                <Cascader filterable style="width: 200px" v-model="productType" :data="optionProTypeList"
                    placeholder="Purchase Product Type" @on-change="changeCategory"></Cascader>
            </div>

            <div class="p-box_select" v-if="isActive">
                <span class="label" style="width: 125px">Purchase quantity</span>
                <Input type="number" placeholder="Purchase quantity" style="
                        width: 200px;
                        height: 42px;
                        margin-left: 20px;
                        margin-top: 6px;
                    " v-model="NeedCount" />
            </div>
            <div class="p-box_select" v-if="isActive">
                <span class="label">Delivery area</span>
                <Cascader filterable style="width: 200px" v-model="ProductArea" :data="optionRegionList"
                    placeholder="Delivery area"></Cascader>
            </div>
            <div class="p-box_select" v-if="isActive">
                <span class="label">Purchase deadline</span>
                <DatePicker type="date" placeholder="Purchase deadline" @on-change="time1" format="yyyy-MM-dd"
                    style="width: 200px"></DatePicker>
            </div>

            <div class="p-box_select" v-if="isActive">
                <span class="label" style="width: 230px">Qualification requirements
                </span>
                <Input type="text" placeholder="Qualification requirements" style="
                        width: 200px;
                        height: 42px;
                        margin-left: 20px;
                        margin-top: 6px;
                    " v-model="Condition" />
            </div>
            <div class="p-box_select" v-if="isActive">
                <span class="label" style="width: 160px">Purchase Description</span>
                <Input type="textarea" placeholder="Purchase Description" style="
                        width: 200px;
                        height: 42px;
                        margin-left: 20px;
                        margin-top: 6px;
                    " v-model="Remark" />
            </div>

            <!-- supplying -->
            <div class="p-box_select" v-if="!isActive">
                <span class="label">Company</span>
                <Input type="text" placeholder="Company" style="
                        width: 200px;
                        height: 42px;
                        margin-left: 20px;
                        margin-top: 6px;
                    " v-model="company" />
            </div>
            <!-- 招商产品  链接到icmef店内的产品-->
            <div class="p-box_select" v-if="!isActive">
                <span class="label" style="margin-left: 0">Merchants products</span>
                <Select v-model="productId" style="width: 200px; height: 42px; margin-top: 6px">
                    <Option v-for="item in proList" :value="item.id" :key="item.name">{{ item.name }}</Option>
                </Select>
            </div>

            <div class="p-box_select" v-if="isActive">
                <span class="label">Contact</span>
                <Input type="text" placeholder="Contact" style="
                        width: 200px;
                        height: 42px;
                        margin-left: 20px;
                        margin-top: 6px;
                    " v-model="name" />
            </div>

            <!-- 联系人   招商 -->
            <div class="p-box_select" v-if="!isActive">
                <span class="label">Contact</span>
                <Select v-model="contactId" style="width: 200px; height: 42px; margin-top: 6px"
                    @on-change="selectContact">
                    <Option v-for="item in contactInfoList" :value="item" :key="item.name">
                        {{ item.name }}</Option>
                </Select>
            </div>


            <div class="p-box_select" v-if="!isActive">
                <span class="label">Posts</span>
                <Input type="text" placeholder="Posts" style="
                        width: 200px;
                        height: 42px;
                        margin-left: 20px;
                        margin-top: 6px;
                    " v-model="posts" />
            </div>
            <!-- 联系邮箱 -->
            <div class="p-box_select">
                <span class="label">E-mail</span>
                <Input type="text" placeholder="E-mail" style="
                        width: 200px;
                        height: 42px;
                        margin-left: 20px;
                        margin-top: 6px;
                    " v-model="email" />
            </div>
            <!-- 招商类别 -->
            <div class="p-box_select" v-if="!isActive">
                <span class="label">Category</span>
                <Input type="text" placeholder="Category" style="
                        width: 200px;
                        height: 42px;
                        margin-left: 20px;
                        margin-top: 6px;
                    " v-model="category" />
            </div>
            <!-- 招商地区 -->
            <div class="p-box_select" v-if="!isActive">
                <span class="label">Region</span>
                <Select style="width: 200px" v-if="countryList" v-model="region" placeholder="Region">
                    <Option v-for="(item, index) in countryList" :value="item.value" :label="$t(item.value)"
                        :key="index">{{ item.value }}</Option>
                </Select>
            </div>
            <!-- 供应周期 -->
            <div class="p-box_select" v-if="!isActive">
                <span class="label">Cycle</span>
                <Input type="text" placeholder="Cycle" style="
                        width: 200px;
                        height: 42px;
                        margin-left: 20px;
                        margin-top: 6px;
                    " v-model="cycle" />
            </div>
            <!-- 供应数量 -->
            <div class="p-box_select" v-if="!isActive">
                <span class="label">Quantity</span>
                <Input type="text" placeholder="Quantity" style="
                        width: 200px;
                        height: 42px;
                        margin-left: 20px;
                        margin-top: 6px;
                    " v-model="quantity" />
            </div>


            <div class="btn" @click="submit()" v-if="isActive">
                Release demand
            </div>
            <div class="btn" @click="submit1()" v-if="!isActive">
                Release demand
            </div>
        </div>



        <div class="brand-box">
            <Row :gutter="20">
                <Col span="8">
                <div class="brand-item">
                    <img src="@assets/img/icon-speed.png" />Efficient
                    Matching
                </div>
                </Col>
                <Col span="8">
                <div class="brand-item">
                    <img src="@assets/img/icon-save.png" />Platform
                    Guarantee
                </div>
                </Col>
                <Col span="8">
                <div class="brand-item">
                    <img src="@assets/img/icon-pei.png" />Advance
                    Compensation
                </div>
                </Col>
            </Row>
        </div>
        <div class="news-list">
            <!-- <div class="news-l">
        <span>最新</span>
      </div> -->
            <!-- <div class="news-r" v-if="newChanceList.length">
                <swiper :options="swiperOption">
                    <swiperSlide v-for="(card, index) in newChanceList" :key="'card' + index">
                        <div class="swiper-li" v-for="(c, index) in card" :key="'c' + index">
                            <div class="news-l">
                                <span>Latest</span>
                            </div>
                            <p>{{ c.information }}</p>
                            <span>{{
                                $service.SmarDateEn(new Date(c.inTime))
                                }}</span>
                        </div>
                    </swiperSlide>
                </swiper>
            </div>
            <div class="no-msg" v-else>No Data！</div> -->
        </div>

        <!-- 发布需求成功提示 -->
        <!-- <Modal v-model="modal" width="538" :footer-hide="true" :class-name="'my-modal ex-release'">
      <div class="demand-modal-content">
        <p>已收到您发布的需求</p>
        <p>我们会尽快联系您，请保持手机畅通，谢谢！</p>
        <Button style="height:40px;font-size:16px;" type="error" @click="modal=false;">关闭</Button>
      </div>
    </Modal> -->
        <gLogin :show="show" :isPwd="isPwd" @close="show = false" @btnclick="descclick" />

        <iModal v-model="centerDialogVisible" width="538" :footer-hide="true" :class-name="'my-modal ex-release'">
            <div class="demand-modal-content">
                <div style="text-align: center">
                    <img v-if="rightIndex == 1" src="@assets/img/supply/1.png" style="width: 300px; height: auto" />
                    <img v-if="rightIndex == 3" src="@assets/img/supply/3.png" style="width: 300px; height: auto" />
                    <img v-if="rightIndex == 4" src="@assets/img/supply/4.png" style="width: 300px; height: auto" />
                    <img v-if="rightIndex == 5" src="@assets/img/supply/5.png" style="width: 350px; height: auto" />
                </div>
                <Button style="height: 40px; font-size: 16px" type="error"
                    @click="centerDialogVisible = false">关闭</Button>
            </div>
        </iModal>

        <!-- <div id="quick-right" class="quick-right">
            <a href="https://i.cmef.com.cn/chanceEn" target="_blank">
                <div class="item">iCMEF Matchmaking</div>
            </a>
            <a href="https://www.cmef.com.cn/en/contactus?cid=4" target="_blank">
                <div class="item">Seek cooperation</div>
            </a>
            <div class="item" @click="clickDialog('4')">iCMEF Mobile</div>
        </div> -->


        <!-- 联系人认证  @on-cancel="close"-->
        <iModal v-model="authDialog" title="Contact authentication" :z-index="1010" class-name="collect-modal myModel"
            width="858">
            <div style="padding: 40px;">
                <Form ref="formAuth" :model="formAuth" :rules="rules_auth" :label-width="140">
                    <FormItem label="Name of authorizer" prop="LinkName">
                        <Input v-model="formAuth.LinkName" placeholder="Name of authorizer"></Input>
                    </FormItem>
                    <FormItem label="Company" prop="LinkCompany">
                        <Input v-model="formAuth.LinkCompany" placeholder="Company"></Input>
                    </FormItem>
                    <FormItem label="Post" prop="LinkName">
                        <Input v-model="formAuth.LinkJobTitle" placeholder="Post"></Input>
                    </FormItem>
                    <FormItem label="Business license" prop="LinkBusinessLicense">

                        <div class='flex_between_center'>
                            <div>
                                <p class='textCen'>Example</p>
                                <img :src="license" style="width: 120px;height:100%;">
                            </div>
                            <div>
                                <p class='textCen'>Upload</p>
                                <Upload ref="upload" :show-upload-list="false" :on-success="handleSuccess6"
                                    :action="uploadUrl2" style="">
                                    <img v-if="formAuth.LinkBusinessLicense" :src="formAuth.LinkBusinessLicense"
                                        style="width: 120px;height:110px">
                                    <img v-else
                                        :src="uploadIcon"
                                        alt="" style="width: 120px;height:110px">
                                </Upload>
                            </div>
                        </div>
                    </FormItem>

                    <FormItem label="power of attorney" prop="LinkPower">
                        <div class='flex_between_center'>
                            <div>
                                <p class='textCen'>Example</p>
                                <img :src="authorizationImg" style="width: 120px;height:100%;">
                            </div>
                            <div>
                                <p class='textCen'>Upload</p>
                                <Upload ref="upload" :show-upload-list="false" :on-success="handleSuccess7"
                                    :action="uploadUrl2" style="">
                                    <img v-if="formAuth.LinkPower" :src="formAuth.LinkPower"
                                        style="width: 120px;height:110px">
                                    <img v-else
                                        :src="uploadIcon"
                                        alt="" style="width: 120px;height:110px">
                                </Upload>
                            </div>
                        </div>


                    </FormItem>
                </Form>


            </div>
            <div slot="footer">
                <Button type="" @click="handleSubCan('formAuth')">cancel</Button>
                <Button type="primary" @click="submitForm_auth('formAuth')">ok</Button>
            </div>
        </iModal>
    </div>
</template>

<script>
import gLogin from '@components/En/gLogin/gLogin.vue'
import { mapActions, mapGetters } from 'vuex'
import { swiper, swiperSlide } from 'vue-awesome-swiper'
import axios from 'axios'
export default {
    name: 'ex-release',
    props: {
        // exhibitionInfo: {
        //   type: Object,
        //   default: null
        // },
        newChanceList: {
            type: Array,
            default: null,
        },
    },
    data () {
        return {

            uploadIcon: 'https://oss.cmef.com.cn/cloudExhibition/imgs/202408/30eae2fd1c374b2a8fe7c26491b76836.png',
            license: 'https://oss.cmef.com.cn/cloudExhibition/imgs/202408/fdd5b614b56a4e9986b30ced781ea43e.png',
            authorizationImg: 'https://oss.cmef.com.cn/cloudExhibition/imgs/202408/328e594e14394defb0c0d26cae8c04c1.png',


            typeId: '',
            typeList: [
                {
                    nameEn: 'Finished medical devices',
                },
                {
                    nameEn: 'Manufacturing supply chain',
                },
            ],
            optionProTypeList: [], //获取产品类型
            proList: [],
            contactInfoList: [],
            companyData: {},
            info: '',
            name: '',
            phone: '',
            company: '',
            email: '',
            productId: '',
            productType: [],
            contactId: '',
            posts: '',
            category: '',
            region: '',
            cycle: '',
            quantity: '',
            NeedCount: '', //采购数量
            ProductArea: [], //交货区域
            EndTime: '', //日期
            Remark: '', //
            Condition: '', //
            optionRegionList: [],
            rule: {
                info: 0,
                name: 0,
                // phone: 0
            },
            modal: false,
            isPwd: false,
            swiperOption: {
                autoplay: true,
                direction: 'vertical',
                loop: true,
                height: 100,
            },
            show: false,
            isActive: false,  //    isActive: true,  最原始的值
            countryList: [],
            FromIdId: '',
            linkMan: '',
            companyList_Computed: '',

            centerDialogVisible: false,
            rightIndex: 0,


            // 招商个人
            zCompanyName: '',
            PersonProdcutName: "",
            PersonProductIntroduction: "",
            // PersonProductImg: "https://oss.cmef.com.cn/cloudExhibition/imgs/202408/2f390a9ee49e4485bac55474c5a02f12.jpg",
            PersonProductImg: "",
            defaultList5:[],
            isAuth: false,
            authDialog: false,
            contactsInfo: {},


            // 认证表单

            formAuth: {
                LinkName: "",
                LinkCompany: "",
                LinkJobTitle: "",
                LinkBusinessLicense: "",
                LinkPower: "",
                // LinkBusinessLicense: "https://oss.cmef.com.cn/cloudExhibition/imgs/202408/845a4020a1c24f408629be617ed4b80b.png",
                //  LinkPower: "https://oss.cmef.com.cn/cloudExhibition/imgs/202408/845a4020a1c24f408629be617ed4b80b.png",
                    },
            rules_auth: {
                LinkName: [
                    { required: true, message: 'Please enter Name of authorizer', trigger: 'blue' },
                ],
                LinkCompany: [
                    { required: true, message: 'Please enter Company', trigger: 'blue' },
                ],
                LinkJobTitle: [
                    { required: true, message: 'Please enter Post', trigger: 'blue' },
                ],
                LinkBusinessLicense: [
                    { required: true, message: 'Please upload Business license', trigger: 'blue' },
                ],
                LinkPower: [
                    { required: true, message: 'Please upload power of attorney', trigger: 'blue' },
                ],
            },

        }
    },
    components: {
        swiper,
        swiperSlide,
        gLogin,
    },
    computed: {
        ...mapGetters({
            user: 'getUser',
            isExLogin: 'getIsExLogin',
            token: 'getToken',
            login_is: 'getLogin',
            exhibition: 'loginModule/getExhibition',
        }),
        uploadUrl2 () {
            return `https://api.cmef.com.cn/api/Upload/images`;
        },

        isExLogin_com () {
            return this.isExLogin;
        },
    },

    watch: {
        isExLogin_com (val, oldVal) {
            if (val == '个人') {
               setTimeout(() => {
                   this.getContactAuth() //联系人认证
               }, 1000);
            }
        }

    },

    created () {

        console.log(this.isExLogin_com,'isExLoginisExLogin');

        // this.init();
        this.Country()
        this.initRegion()
        this.initProType()

        let emailLogin = sessionStorage.getItem('emailLogin')
        if (emailLogin) {
            this.getContactAuth()
        }

    },

    methods: {
        ...mapActions({
            sendRelease: 'hall/sendRelease',
            sendReleaseNew: 'hall/sendReleaseNew',
            getRelease: 'hall/getRelease',
            getCountry: 'getCountry',
            postNewRealease: 'loginModule/postNewRealease',
        }),

        handleSuccess5 (res, file) {
            console.log(res, "ressssssssss");
            if (res && res.list.length) {
                file.url = res.list[0];
                this.PersonProductImg = res.list[0]
                // this.uploadList5.push({
                //     name: this.uploadName5,
                //     url: res.list[0],
                //     status: "finished",
                // });
            }
        },
        handleSuccess6 (res, file) {
            console.log(res, "ressssssssss");
            if (res && res.list.length) {
                file.url = res.list[0];
                this.formAuth.LinkBusinessLicense = res.list[0]
            }
        },
        handleSuccess7 (res, file) {
            console.log(res, "ressssssssss");
            if (res && res.list.length) {
                file.url = res.list[0];
                this.formAuth.LinkPower = res.list[0]
            }
        },

        // 联系人认证
        getContactAuth () {
            axios.get('https://api.cmef.com.cn/api/UserInfo/memeberLinkAuth?userId=' + this.user.userId,
                {
                    headers: {
                        "Authorization": "Bearer " + this.token,
                    },
                }
            )
                .then((res) => {
                    this.isAuth = res.data.successed
                    if (this.isAuth) {
                        this.getInfoUser(this.user.userId)
                    }
                    console.log(res.data.successed, 'lianxiren')
                })
        },

        // 查询认证的联系人信息  把数据填充到发布调用的接口中去
        getInfoUser (id) {
            axios.get('https://api.cmef.com.cn/api/UserInfo/getMemberByUserId?userId=' + id,
                {
                    headers: {
                        "Authorization": "Bearer " + this.token,
                    },
                }
            )
                .then((res) => {
                    if (res) {
                        this.contactsInfo = res.data
                        console.log(this.contactsInfo, '认证人员信息');
                    }
                })
        },


        goAuthentication () {
            if (this.isAuth) {
                this.formAuth.LinkName = this.contactsInfo.linkName
                this.formAuth.LinkCompany = this.contactsInfo.linkCompany
                this.formAuth.LinkJobTitle = this.contactsInfo.linkJobTitle
                this.formAuth.LinkPower = this.contactsInfo.linkPower
                this.formAuth.LinkBusinessLicense = this.contactsInfo.linkBusinessLicense
            }

            this.authDialog = true
        },

        async submitForm_auth (formName) {

            let valid = await this.validForm(formName);
            if (!valid) return;
            let opt = {
                id: this.user.userId,
                setValues: {
                    LinkName: this.formAuth.LinkName,
                    LinkCompany: this.formAuth.LinkCompany,
                    LinkJobTitle: this.formAuth.LinkJobTitle,
                    LinkBusinessLicense: this.formAuth.LinkBusinessLicense,
                    LinkPower: this.formAuth.LinkPower,
                    LinkAuth: true
                }
            }

            axios.put('https://api.cmef.com.cn/api/UserInfo/memberUpdateByUserId', opt,
                {
                    headers: {
                        "Authorization": "Bearer " + this.token,
                    },
                }
            )
                .then(res => {
                    if (res.data.successed) {
                        this.$Message.success("联系人认证成功");
                        this.authDialog = false
                        this.getContactAuth()

                    } else {
                        this.$Message.error(res.data.msg)
                    }
                    console.log(res.data.successed, '提交认证')
                })
                .catch(function (error) { // 请求失败处理
                    console.log(error);
                });


        },
        handleSubCan (name) {
            this.$refs[name].resetFields();
            this.authDialog=false
        },
        validForm (name) {
            // 验证表单
            return new Promise((resolve, reject) => {
                this.$refs[name].validate((valid) => {
                    resolve(valid)
                })
            })
        },


        clickDialog (e) {
            this.rightIndex = e
            this.centerDialogVisible = true
        },

        async descclick (item, item1, item2) {
            // companyData
            this.FromIdId = item.id
            this.company = item.name
            this.category = item.businessType
            this.contactInfoList = item1

            this.proList = item2.items
            this.isActive = false
        },
        selectContact (e) {
            this.linkMan = e.name

            this.posts = e.jobTitle
            this.email = e.email
        },

        async Country () {
            let arr = await this.getCountry()
            for (let i = 0; i < arr.length; i++) {
                let obj = {}
                obj.value = arr[i].nameEn
                obj.lable = arr[i].nameEn
                this.countryList.push(obj)
            }
        },
        formValid () {
            if (this.info === '') {
                this.rule.info = 1
            } else {
                this.rule.info = 0
            }
            if (this.name === '') {
                this.rule.name = 1
            } else {
                this.rule.name = 0
            }
            // if (this.phone === "" || /^[1][0-9]{10}$/.test(this.phone) === false) {
            //     this.rule.phone = 1;
            // } else {
            //     this.rule.phone = 0;
            // }
            if (
                this.rule.info === 1 ||
                this.rule.name === 1 ||
                this.rule.phone === 1
            ) {
                return false
            } else {
                return true
            }
        },

        // 采购
        async submit (value) {
            // let emailLogin = sessionStorage.getItem('emailLogin')
            // if (!emailLogin) {
            //     this.$Message.warning('Please log in to post')
            //     this.show = true
            //     return
            // }
            let a = await this.is_login()
            if (a == 1) {
                return
            }

            if (!this.typeId) {
                this.$Message.warning(
                    'Please select the Supply and demand type'
                )
                return
            }
            if (!this.productType) {
                this.$Message.warning('Please select the Purchase Product Type')
                return
            }
            if (!this.NeedCount) {
                this.$Message.warning('Please enter the Purchase quantity')
                return
            }
            if (!this.ProductArea) {
                this.$Message.warning('Please select the Delivery area')
                return
            }
            if (!this.EndTime) {
                this.$Message.warning('Please select the Purchase deadline')
                return
            }
            if (!this.Condition) {
                this.$Message.warning(
                    'Please enter the Qualification requirements'
                )
                return
            }
            if (!this.Remark) {
                this.$Message.warning('Please enter the Purchase Description')
                return
            }

            if (!this.name) {
                this.$Message.warning('Please enter the person to contact')
                return
            }

            if (!this.email) {
                this.$Message.warning('Please enter the E-mail')
                return
            }

            // const valid = this.formValid();
            // if (!valid) return;
            let list = []
            list.push(this.ProductArea)
            let jsonProductArea = JSON.stringify(list)

            var PublishType
            if (this.typeId == 'Finished medical devices') {
                PublishType = '医疗器械成品'
            } else {
                PublishType = '制造供应链'
            }
            let emailLogin = sessionStorage.getItem('emailLogin')
            var req = {
                // AgentId: this.exhibition.agentId,
                // ExhibitionId: this.exhibition.id,
                // TypeId: this.typeId,
                // FromType: 1, // 《0：企业，1：用户》(小程序端只有用户)
                // FromId: this.user.userId,
                // Information: this.info,
                // Subtitle: this.name, // 联系人
                // Phone: this.phone,


                // FormType: this.isLogin_per ? 1 : 0, // 0 公司  1个人

                CallingCardImg: '',
                Category: this.productType,
                CategotyId: this.idCategory,
                CompanyName: '',
                Condition: this.Condition,
                Email: this.email,
                EndTime: this.EndTime,
                FormType: emailLogin ? 1 : 0, // 0 公司  1个人
                FromId: this.user.userId,
                HeadImg: '',
                IdnentityType: '',
                JobTitle: '',
                Name: this.name,
                NeedCount: this.NeedCount,
                Phone: this.phone,
                ProductArea: jsonProductArea,
                ProductType: JSON.stringify(this.ProductTypeData),
                PublishType: PublishType,
                Remark: this.Remark,
                Sex: '',
                Subtitle: '',
                Title: '',
            }
            console.log(req)

            var result = await this.sendReleaseNew(req)
            if (result.successed) {
                this.$Message.success('Successfully published!')
                this.typeId = ''
                this.productType = ''
                this.NeedCount = ''
                this.ProductArea = ''
                this.EndTime = ''
                this.Condition = ''
                this.Remark = ''
                this.name = ''
                this.phone = ''
                this.email = ''
                this.modal = true
                this.$emit('finish')
            } else {
                this.loading = false
                if (result.errors && result.errors[0]) {
                    this.$Message.error(result.errors[0].description)
                    return
                } else {
                    this.$Message.error('发布失败，请重试')
                }
            }
        },

        //   postNewRealease 招商发布
        async submit1 () {
            // let accountPassword = sessionStorage.getItem('accountPassword')
            // if (!accountPassword) {
            //     this.$Message.warning('Please log in to post')
            //     this.show = true
            //     return
            // }

            let aa = await this.is_login()
            if (aa == 1) {
                return
            }

            console.log(this.linkMan)
            if (!this.company) {
                this.$Message.warning('Please enter the company')
                return
            }
            if (!this.productId) {
                this.$Message.warning('Please select the Merchants products')
                return
            }
            if (!this.linkMan) {
                this.$Message.warning('Please select the Contact')
                return
            }
            if (!this.posts) {
                this.$Message.warning('Please enter the Posts')
                return
            }
            if (!this.email) {
                this.$Message.warning('Please enter the E-mail')
                return
            }
            if (!this.category) {
                this.$Message.warning('Please enter the Category')
                return
            }
            if (!this.region) {
                this.$Message.warning('Please select the Region')
                return
            }
            if (!this.cycle) {
                this.$Message.warning('Please enter the cycle')
                return
            }
            if (!this.quantity) {
                this.$Message.warning('Please enter the quantity')
                return
            }

            let a = []
            let b = []
            a.push(this.region)
            b.push(a)

            let emailLogin = sessionStorage.getItem('emailLogin')
            let opt = {
                CompanyName: this.company,
                Email: this.email,
                FormType: emailLogin ? 1 : 0, // 0 公司  1个人
                FromId: this.user.userId,
                // FromId: this.FromIdId,
                HeadImg: '',
                IdnentityType: this.category,
                JobTitle: this.posts,
                Name: this.linkMan,
                Phone: '',
                ProductArea: JSON.stringify(b),
                ProductId: this.productId,
                PublishType: '招商发布',
                Subtitle: '',
                SupplyCount: this.cycle,
                SupplyDate: this.quantity,
                Title: '',
            }
            let res = await this.postNewRealease(opt)
            if (res.successed) {
                this.$Message.success('Successfully published!')
                this.company = ''
                this.email = ''
                this.contactId = ''
                this.category = ''
                this.posts = ''
                this.linkMan = ''
                this.productId = ''
                this.cycle = ''
                this.region = ''
                this.quantity = ''
            } else {
                this.$Message.error('发布失败，请重试')
            }
        },



        async zSubmitForm_per () {
            let a = await this.is_login()
            if (a == 1) {
                return
            }
            let that = this
            if (!this.zCompanyName) {
                this.$Message.warning('Please enter')
                return
            }
            if (!this.PersonProdcutName) {
                this.$Message.warning('Please enter')
                return
            }
            if (!this.PersonProductIntroduction) {
                this.$Message.warning('Please enter')
                return
            }
            if (!this.PersonProductImg) {
                this.$Message.warning('Please enter')
                return
            }

            if (!this.isAuth) {
                this.$Message.error('Please authenticate the contact person')
                return
            }
            let data = {
                CompanyName: this.zCompanyName,
                FromType: 1, //0 公司  1个人
                FromId: this.user.userId,
                PersonProdcutName: this.PersonProdcutName,
                PersonProductIntroduction: this.PersonProductIntroduction,
                PersonProductImg: this.PersonProductImg,
                PublishType: '招商发布',

                // contactsInfo ；联系人认证的信息
                Email: this.contactsInfo.email,
                Phone: this.contactsInfo.phoneNumber,
                Name: this.contactsInfo.linkName,
                JobTitle: this.contactsInfo.linkJobTitle,
                HeadImg: this.contactsInfo.logo ? this.contactsInfo.logo : 'https://www.cmef.com.cn/Content/images/cmef-demand-logo.png',
                title: '',
                Subtitle: '',
            }

            axios.post('https://api.cmef.com.cn/api/NewRealease', {
                ...data,
            }).then(response => {
                that.zCompanyName = ''
                that.PersonProdcutName = ''
                that.PersonProductIntroduction = ''
                that.PersonProductImg = ''
                this.$Message.success("需求已发布");
            }).catch(function (error) {
                console.log(error);
            });

        },

        // async init () {
        //     let typeList = await this.getRelease(this.exhibition.id);
        //     this.typeList = typeList;
        // },

        is_login () {
            //  看是否是个人登录  个人没登录 就去查展商是否登录
            // sessionStorage.setItem('accountPassword', true)
            // sessionStorage.setItem('emailLogin', true)

            let emailLogin = sessionStorage.getItem('emailLogin')
            let accountPassword = sessionStorage.getItem('accountPassword')


            let allLoginNo = 0
            if (!this.login_is) {
                this.show = true
                this.isPwd = false
                allLoginNo = 1
            }
            // if (!emailLogin) {
            //     if (!accountPassword) {
            //         this.show = true
            //         this.isPwd = false
            //         allLoginNo = 1
            //     }
            // }
            return allLoginNo
        },

        // 采购
        isActiveChange1 () {
            this.is_login()
            this.productType = []
            this.isActive = true

            // this.isPwd = false
            // let emailLogin = sessionStorage.getItem('emailLogin')
            // console.log(emailLogin)
            // if (!emailLogin) {
            //     this.show = true
            //     return
            // }
        },
        // 招商
        isActiveChange2 () {
            // this.isPwd = true
            // let accountPassword = sessionStorage.getItem('accountPassword')
            // console.log(accountPassword)
            // if (!accountPassword) {
            //     this.show = true
            //     return
            // }
            this.is_login()
            this.isActive = false
            if (sessionStorage.getItem('companyListLogin')) {
                let companyListLogin = JSON.parse(
                    sessionStorage.getItem('companyListLogin')
                )
                let byCompIdListLogin = JSON.parse(
                    sessionStorage.getItem('byCompIdListLogin')
                )
                let proListLogin = JSON.parse(
                    sessionStorage.getItem('proListLogin')
                )
                this.descclick(
                    companyListLogin,
                    byCompIdListLogin,
                    proListLogin
                )
            }

        },

        // 获取产品类型
        initProType () {
            let body = {
                ByGroupId: 1,
                level: 0,
                loadChild: true,
            }
            axios
                .get(
                    'https://api.cmef.com.cn/api/Category/ByGroupId?level=0&loadChild=true',
                    {
                        params: body,
                    }
                )
                .then((response) => {
                    if (response.data && response.data.length) {
                        response.data.map((c) => {
                            c.value = c.nameEn
                            c.label = c.nameEn
                            c.children = JSON.parse(JSON.stringify(c.list))
                            c.children.map((v) => {
                                v.value = v.nameEn
                                v.label = v.nameEn
                                v.children = JSON.parse(JSON.stringify(v.list))
                                v.children.map((z) => {
                                    z.value = z.nameEn
                                    z.label = z.nameEn
                                    z.children = JSON.parse(
                                        JSON.stringify(z.list)
                                    )
                                })
                            })
                        })
                        // this.getTypeList(response.data)
                        this.optionProTypeList = response.data
                        console.log(
                            this.optionProTypeList,
                            ']]]]]]]]]]]]]]]]]]'
                        )
                    } else {
                        this.optionProTypeList = []
                    }
                })
                .catch(function (error) {
                    // 请求失败处理
                    console.log(error)
                })
        },

        // 处理数据，判断数据children是否有数据
        getTypeList (listData) {
            listData.forEach((items) => {
                if (items.children.length > 0) {
                    this.getTypeList(items.children)
                } else {
                    items.children = undefined
                }
            })
        },

        // @* 选择产品类别触发的事件 *@
        changeCategory (val) {
            console.log(this.productType, '5555555555555555555')
            let category = this.productType
            if (val) {
                category = this.productType = val
            }
            let data = null
            this.optionProTypeList.forEach((c) => {
                if (category[0] && c.nameEn === category[0]) {
                    this.idCategory = c.id
                    data = {
                        Id: c.id,
                        Value: c.nameEn,
                        List: [],
                    }
                    if (c.list && c.list.length && category[1]) {
                        c.list.forEach((v) => {
                            if (v.nameEn === category[1]) {
                                this.idCategory = v.id
                                data.List[0] = {
                                    Id: v.id,
                                    Value: v.nameEn,
                                }
                                if (v.list && v.list.length && category[2]) {
                                    v.list.forEach((j) => {
                                        if (j.nameEn === category[2]) {
                                            this.idCategory = j.id
                                            data.List[0].list = [
                                                {
                                                    Id: j.id,
                                                    Value: j.nameEn,
                                                    Remark: j.tag,
                                                },
                                            ]
                                        }
                                    })
                                }
                            }
                        })
                    }
                }
            })
            console.log(this.idCategory)
            this.ProductTypeData = data
            console.log(data)

            return data
        },

        // @* 获取交货区域 *@
        initRegion () {
            axios
                .get('https://api.cmef.com.cn/api/Region/GetListAndChildren', {
                    headers: {
                        // 设置请求头
                        Authorization: this.token,
                    },
                })
                .then((response) => {
                    console.log(response.data, '00000000000000000000')
                    if (response.data && response.data.length) {
                        response.data.map((c) => {
                            c.value = c.nameEn
                            c.label = c.nameEn
                            c.children = JSON.parse(JSON.stringify(c.list))
                            c.children.map((v) => {
                                v.value = v.nameEn
                                v.label = v.nameEn
                                v.children = JSON.parse(JSON.stringify(v.list))
                                v.children.map((z) => {
                                    z.value = z.nameEn
                                    z.label = z.nameEn
                                    z.children = JSON.parse(
                                        JSON.stringify(z.list)
                                    )
                                })
                            })
                        })
                        console.log(response.data, 'hhhhhhh')
                        // this.getTypeList(response.data)
                        this.optionRegionList = response.data
                    } else {
                        this.optionRegionList = []
                    }
                    this.optionRegionList = response.data
                })
                .catch(function (error) {
                    // 请求失败处理
                    console.log(error)
                })
        },

        time1 (e) {
            this.EndTime = e
        },
    },
}
</script>

<style scoped lang="scss">
.backImgColor {
    background-image: linear-gradient(-90deg, #ff4062 0%, #ff7c3c 100%),
        linear-gradient(#f2f2f2, #f2f2f2);
    color: #fff;
}

.ex-release {
    display: inline-block;
    width: 376px;
    height: 566px;
    background-color: #fff;
    border: solid 1px #f2eded;
    border: solid 1px #f2eded;

    .title {
        line-height: 48px;
        font-size: 18px;
        // padding-left: 20px;
        color: #333;
        font-family: MicrosoftYaHei-Bold;
        border-bottom: 2px solid #c5161b;
        // font-weight: bold;

        display: flex;
        justify-content: space-evenly;
        align-items: center;
    }

    .title p {
        width: 50%;
        text-align: center;
    }

    .p-box {
        &_select {
            padding: 14px 27px 0 20px;
            display: flex;
            justify-content: space-between;
            align-items: center;

            .label {
                display: inline-block;
                // margin-left: 14px;
            }

            // ::v-deep .ivu-select-selection {
            //   height: 40px;
            // }
            // ::v-deep .ivu-select-single .ivu-select-selection .ivu-select-placeholder {
            //   line-height: 40px;
            // }
            // ::v-deep .ivu-select-single .ivu-select-selection .ivu-select-selected-value {
            //   line-height: 40px;
            // }
        }

        &_item {
            position: relative;
            width: 320px;
            margin-left: auto;
            margin-right: auto;
            background-color: #f2f2f2;
            line-height: 40px;
            border-radius: 4px;
            margin-bottom: 20px;
            padding: 0 14px;
            transition: all 0.5s;
            border: 1px solid #fff;

            input {
                outline: none;
                border: none;
                background: #f2f2f2;
                width: 200px;
                margin-left: 20px;
                line-height: 30px;
                height: 30px;
                font-size: 14px;
            }

            .label {
                display: inline-block;
                font-size: 14px;
                color: #333;
                // margin-right: 14px;
            }
        }

        .btn {
            width: 320px;
            height: 40px;
            line-height: 40px;
            background-color: #ff5f50\9;
            /* For IE8+ */
            background-image: linear-gradient(-90deg, #ff4062 0%, #ff7c3c 100%),
                linear-gradient(#f2f2f2, #f2f2f2);
            background-blend-mode: normal, normal;
            border-radius: 4px;
            font-size: 14px;
            color: #fff;
            text-align: center;
            margin-bottom: 14px;
            margin: 30px auto 0;
            cursor: pointer;
        }
    }

    .brand-box {
        width: 320px;
        margin: 0 auto;
        text-align: center;
        padding-top: 30px;
        padding-bottom: 20px;

        .brand-item {
            height: 23px;
            line-height: 23px;
            display: inline-block;
            position: relative;
            padding-left: 25px;
            font-size: 12px;
            color: #666;
            display: flex;
            align-items: center;

            img {
                position: absolute;
                top: 0;
                left: 0;
            }
        }
    }

    .active {
        border: 1px solid red;
    }
}

.demand-modal-content {
    padding: 70px 90px 50px 90px;

    p {
        font-size: 16px;
        color: #333;
        text-align: center;
    }

    button {
        width: 180px;
        height: 32px;
        margin-top: 60px;
        margin-left: 73px;
        background-color: #db2a4b;
    }
}

.news-list {
    border-top: 1px solid #efefee;
    display: flex;
    margin: 0 15px;

    .news-r {
        width: 100%;
        overflow: hidden;
        height: 100px;
        margin-top: 13px;

        .swiper-li {
            display: flex;
            justify-content: space-between;
            line-height: 33px;
            font-size: 12px;
            color: #4d4d4d;

            p {
                width: 65%;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
            }

            span {
                width: 30%;
                text-align: right;
            }

            .news-l {
                padding: 0 6px 0 10px;

                span {
                    display: inline-block;
                    width: 40px;
                    height: 20px;
                    border-radius: 4px;
                    border: solid 1px #0190fe;
                    font-size: 12px;
                    color: #0190fe;
                    line-height: 20px;
                    text-align: center;
                }
            }
        }
    }
}

.no-msg {
    font-size: 14px;
    color: #666;
    text-align: center;
    margin-top: 50px;
    width: 100%;
}
</style>
<style lang="scss">
// .ivu-message {
//     z-index: 1050 !important;
// }

.ivu-cascader-menu {
    width: 200px;
}

.quick-right {
    position: fixed;
    right: 0;
    top: 15%;
    z-index: 1;
    font-size: 16px;
    font-weight: normal;
    font-stretch: normal;
    line-height: 18px;
    letter-spacing: 0px;
}

.quick-right a {
    text-decoration: none;
    padding: 0;
}

.quick-right .item {
    cursor: pointer;
    width: 190px;
    height: 42px;
    background-color: #00bdca;
    border-radius: 16px 0px 0px 16px;
    color: #fff;
    line-height: 42px;
    text-align: center;
    margin-top: 10px;
}

.resetAllCss {
    width: 100px;
    height: 40px;
    line-height: 40px;
    border-radius: 5px;
    color: #fff;
    background-color: #00bdca;
    text-align: center;
    display: inline-block;
    font-size: 14px;
    cursor: pointer;
}

 .flex_between_center {
     display: flex;
     justify-content: space-between;
     align-items: center
 }

 .textCen {
     text-align: center;
 }
</style>
